import { render, staticRenderFns } from "./BannerPicture.vue?vue&type=template&id=b07b5f88&scoped=true&"
import script from "./BannerPicture.vue?vue&type=script&lang=js&"
export * from "./BannerPicture.vue?vue&type=script&lang=js&"
import style0 from "./BannerPicture.vue?vue&type=style&index=0&id=b07b5f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07b5f88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b07b5f88')) {
      api.createRecord('b07b5f88', component.options)
    } else {
      api.reload('b07b5f88', component.options)
    }
    module.hot.accept("./BannerPicture.vue?vue&type=template&id=b07b5f88&scoped=true&", function () {
      api.rerender('b07b5f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leaderboard/campaign/components/BannerPicture.vue"
export default component.exports